import React from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {connect} from 'react-redux';

import {CHECKOUT_PAYMENT_STEP} from 'constants/analytics/events/checkout';
import {ApplicationStoreType} from 'desktop/store';

import {PaymentType} from '../../../../../types/PaymentMethodsType';

import {PAYMENTS} from '../../constants/paymentStep';
import {setOptionPaymentMethod} from '../../store/reducers/analytics/analytics';
import {sendPayerInfoToSaga} from '../../store/reducers/paymentStep/payerInfo/payerInfo';
import {
    getIsSelectedByKey,
    getPaymentMethodByKey,
} from '../../store/selectors/paymentStep/paymentStep';
import {PaymentFooter} from '../paymentFooter/paymentFooter';
import {PaymentWrapperConnected} from '../paymentWrapper/paymentWrapper';

type DataForSendPayerType = {
    method: string;
    title: string;
};

export type PropsType = {
    paymentKey: PAYMENTS;
    method: PaymentType;
    isSelected: boolean;
    sendPayerInfo: (data: DataForSendPayerType) => void;
    setOptionMethod: () => void;
};

/**
 * Default payment step for checkout
 *
 * @constructor
 */
export const PaymentDefault: React.FC<PropsType> = ({
    isSelected,
    method,
    sendPayerInfo,
    setOptionMethod,
}) => {
    const sendForm = () => {
        sendDesktopAnalyticsEvent(CHECKOUT_PAYMENT_STEP, {
            message: `CTA - ${method.title}`,
            method: 'Payment',
        });

        sendPayerInfo({
            method: method.code,
            title: method.title,
        });
        setOptionMethod();
    };

    return (
        <PaymentWrapperConnected code={method.code} isSelected={isSelected} title={method.title}>
            <PaymentFooter onSubmit={sendForm} />
        </PaymentWrapperConnected>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType, {paymentKey}: {paymentKey: PAYMENTS}) => ({
    isSelected: getIsSelectedByKey(store, paymentKey),
    method: getPaymentMethodByKey(store, paymentKey),
});

const mapDispatchToProps = {
    sendPayerInfo: sendPayerInfoToSaga,
    setOptionMethod: setOptionPaymentMethod,
};

export const PaymentDefaultConnected = connect(mapStateToProps, mapDispatchToProps)(PaymentDefault);
